(function (w, d) {
	const header = d.querySelector('.js-header-area');
	const throttleTime = 200;

	function toggleStickyHeaderClass() {
		if (w.innerWidth < 960 && w.scrollY) {
			header.classList.add('header__area_is-fixed');
		} else {
			header.classList.remove('header__area_is-fixed');
		}
	}

	w.addEventListener('scroll', throttle(toggleStickyHeaderClass, throttleTime));
})(window, document);
